"use strict";
// Based on the Meeple Colors: https://meeplesource.com/proddetail.php?prod=16mmAll-10Each
Object.defineProperty(exports, "__esModule", { value: true });
exports.UNASSIGNED_COLOR = exports.PlayerColors = void 0;
exports.PlayerColors = {
    Red: '#FF0000',
    // Yellow: '#FFFF00', // invisible on white background
    Green: '#008000',
    Blue: '#0000FF',
    Orange: '#FFA500',
    Purple: '#800080',
    BrightGreen: '#00FF00',
    Pink: '#FFC0CB',
    DarkBrown: '#654321',
    Black: '#000000',
    White: '#FFFFFF',
    Grey: '#808080',
    Gold: '#D4AF37',
    // Tan: '#D2B48C',
    // Silver: '#C0C0C0', too grey
    Copper: '#B87333',
    Turquoise: '#40E0D0',
    Lavender: '#E6E6FA',
    SkyBlue: '#87CEEB',
    Salmon: '#FA8072',
};
exports.UNASSIGNED_COLOR = '#303030';
// const PSOD = '#AB00AB';
//# sourceMappingURL=Colors.js.map